import useSWR from "swr";
import { getAllAvailableValidCharacters } from "../services/template-service";

/**
 * Custom hook to fetch and cache all available valid characters (master list).
 * Uses SWR for caching and automatic revalidation.
 */
const useAvailableValidCharacters = () => {
  const { data, error, mutate } = useSWR(
    "/cleaning/template/valid-characters",
    getAllAvailableValidCharacters,
  );

  return {
    availableCharacters: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export default useAvailableValidCharacters;
